import { AbstractMesh, Quaternion } from '@babylonjs/core'
import { Vector3 } from '@babylonjs/core/Maths/math.vector'
import { TransformNode } from '@babylonjs/core/Meshes/transformNode'
import Part from './Part'
import { Frame } from '../Frame'

export default class Crossbar extends Part {
	

	constructor(parent: TransformNode, mirror: boolean = false) {
		super('CROSSBAR', parent, mirror)		
	}
	
	alignToFrame(frame:Frame) {
		const [slot1, slot2] = frame.getChildTransformNodes(false, x => x.name == "CROSSBAR-OUT") //Align crossbar
		if(slot1 && slot2){
			slot1.computeWorldMatrix(true)
			slot2.computeWorldMatrix(true)
			this.position.copyFrom(Vector3.Center(slot1.getAbsolutePosition(), slot2.getAbsolutePosition()))
			
			const q1 = Quaternion.FromRotationMatrix(slot1.getWorldMatrix())
			const q2 =  Quaternion.FromRotationMatrix(slot2.getWorldMatrix())
			this.rotationQuaternion = Quaternion.Slerp(q1, q2, 0.5)
		}			
	}

	override get filename(): string {
		return this.config.components.CROSSBAR ? `Crossbars/${this.isPrecious ? 'Precious' : 'Titanium'}/${[this.config.components.CROSSBAR.design, this.config.components.CROSSBAR.size].filter(Boolean).join(' ')}` : null
	}

	override get isPrecious(): boolean {
		return this.config.components.CROSSBAR?.color?.startsWith('AU750') || this.config.components.CROSSBAR?.color?.startsWith('PT950')
	}

	override getMeshMaterialName(mesh: AbstractMesh): string {
		if (mesh.name == 'CROSSBAR') {
			return this.config.components.CROSSBAR?.color
		} else {
			throw (`Unexpected ${this.name} mesh: (${mesh.name})`)
		}
	}

	override swap(animated: boolean = false) {
		super.swap(animated)
		// this.position = new Vector3(0, -this.LensOutLeft.position.y, -this.LensOutLeft.position.z)
		// if(this.config.components.BRIDGE?.color) this.getChildMeshes(true, x=>x.name == "BRIDGE").map(x => x.material = this.getScene().getMaterialByName(this.config.components.BRIDGE.color))

		// this.getComponentMeshes("BRIDGE", ).flat().forEach(mesh => this.assignMaterial(mesh, this.config.components["BRIDGE"]?.color))
	}
}
